import { render, staticRenderFns } from "./left-right.vue?vue&type=template&id=07270441&scoped=true&"
import script from "./left-right.vue?vue&type=script&lang=js&"
export * from "./left-right.vue?vue&type=script&lang=js&"
import style0 from "./left-right.vue?vue&type=style&index=0&id=07270441&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07270441",
  null
  
)

export default component.exports